import styles from "./BundleClaimConfirmModal.module.scss"

import ModalDialog from "@/main/components/ui/ModalDialog/ModalDialog"
import { CancelForListFragment } from "@/main/gql/__generated__/graphql"
import { useCancelTypeInfos } from "@/main/lib/useCancelTypeInfos"
import { useMediaQueryContext } from "@/provider/MediaQueryProvider"

type Props = {
	isOpen: boolean
	onClose: () => void
	selectedCancels: CancelForListFragment[]
	isSubmitting: boolean
	onConfirm: () => void
}

const BundleClaimConfirmModal = ({
	isOpen,
	onClose,
	selectedCancels,
	isSubmitting,
	onConfirm,
}: Props) => {
	const { getCancelTypeLabel } = useCancelTypeInfos()
	const { isMobile } = useMediaQueryContext()

	return (
		<ModalDialog
			isOpen={isOpen}
			onOpenChange={(open) => {
				if (!open) onClose()
			}}
			contentClassName={
				isMobile ? styles.sp_modal_content : styles.modal_content
			}
		>
			{isMobile ? (
				<div className={styles.sp_modal_card}>
					<h2 className={styles.sp_title}>キャンセル料を請求しますか？</h2>
					<p className={styles.sp_desc}>
						以下の{selectedCancels.length}
						件のキャンセルに対してキャンセル料を請求します。
					</p>
					<div className={styles.sp_card_list}>
						{selectedCancels.map((cancel) => (
							<div key={cancel.idv2} className={styles.sp_card}>
								<div className={styles.sp_card_header}>
									<span className={styles.sp_card_name}>{cancel.name}</span>
								</div>
								<div className={styles.sp_card_row}>
									<span className={styles.sp_label}>キャンセル種別:</span>
									<span>{getCancelTypeLabel(cancel.cancelType)}</span>
								</div>
								<div className={styles.sp_card_row}>
									<span className={styles.sp_label}>キャンセル料金:</span>
									<span>¥{cancel.invoicePrice.toLocaleString()}</span>
								</div>
								<div className={styles.sp_card_row}>
									<span className={styles.sp_label}>電話番号:</span>
									<span>{cancel.phoneNumber || "—"}</span>
								</div>
								<div className={styles.sp_card_row}>
									<span className={styles.sp_label}>来店予定日:</span>
									<span>{cancel.dateVisit}</span>
								</div>
								<div className={styles.sp_card_row}>
									<span className={styles.sp_label}>担当スタッフ:</span>
									<span>{cancel.staffName || "—"}</span>
								</div>
							</div>
						))}
					</div>
					<div className={styles.sp_buttons}>
						<button
							className={styles.sp_confirm_btn}
							onClick={onConfirm}
							disabled={isSubmitting}
						>
							{isSubmitting ? "請求中..." : "請求する"}
						</button>
						<button
							className={styles.sp_cancel_btn}
							onClick={onClose}
							disabled={isSubmitting}
						>
							キャンセル
						</button>
					</div>
				</div>
			) : (
				<div className={styles.modal_card}>
					<h2 className={styles.modal_title}>キャンセル料を請求しますか？</h2>
					<p className={styles.modal_desc}>
						以下の{selectedCancels.length}
						件のキャンセルに対してキャンセル料を請求します。
					</p>
					<div className={styles.claim_table}>
						<div className={styles.table_header}>
							<span className={styles.col_name}>請求先</span>
							<span className={styles.col_cancel_type}>キャンセル種別</span>
							<span className={styles.col_fee}>キャンセル料金</span>
							<span className={styles.col_phone}>電話番号</span>
							<span className={styles.col_date}>来店予定日</span>
							<span className={styles.col_staff}>担当スタッフ</span>
						</div>
						{selectedCancels.map((cancel) => (
							<div key={cancel.idv2} className={styles.table_row}>
								<span className={styles.col_name}>{cancel.name}</span>
								<span className={styles.col_cancel_type}>
									{getCancelTypeLabel(cancel.cancelType)}
								</span>
								<span className={styles.col_fee}>
									¥{cancel.invoicePrice.toLocaleString()}
								</span>
								<span className={styles.col_phone}>
									{cancel.phoneNumber || "—"}
								</span>
								<span className={styles.col_date}>{cancel.dateVisit}</span>
								<span className={styles.col_staff}>
									{cancel.staffName || "—"}
								</span>
							</div>
						))}
					</div>
					<div className={styles.modal_buttons}>
						<button
							className={styles.cancel_btn}
							onClick={onClose}
							disabled={isSubmitting}
						>
							キャンセル
						</button>
						<button
							className={styles.confirm_btn}
							onClick={onConfirm}
							disabled={isSubmitting}
						>
							{isSubmitting ? "請求中..." : "請求する"}
						</button>
					</div>
				</div>
			)}
		</ModalDialog>
	)
}

export default BundleClaimConfirmModal
